<script setup>
	import { VBtn, VSnackbar } from "vuetify/components";

	const props = defineProps({
		message: String,
	});

	const emit = defineEmits([ "close" ]);

	function raiseCloseEmit() {
		emit("close");
	}
</script>

<template>
	<VSnackbar timeout="4000" rounded="pill">
		<span class="dialog-message">{{ props.message }}</span>
		<template v-slot:actions>
			<VBtn color="primary" variant="text" @click="raiseCloseEmit">Close</VBtn>
		</template>
	</VSnackbar>
</template>
